import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useExportDataBl } from '../../ExportData.bl';
import { IExportDataStore } from '../../ExportData.store';
import { InformationModal } from './InformationModal';

export const InformationModalContainer = observer((): ReactElement => {
  const bl = useExportDataBl();
  const store = useInjection(IExportDataStore.$);

  const handleHide = (): void => {
    bl.hideExportModal();
  };

  return (
    <InformationModal
      show={store.showExportModal}
      onHide={handleHide}
    />
  );
});
